import { IsNotEmpty, IsUUID } from 'class-validator';

import { UploadLogoRequest } from '@app/gen/settings';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
};

export class UploadLogoDto extends UploadLogoRequest {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  companyId: string;
}
